import { Button } from '@altify/components';
import { ActiveProductDtoTypeEnum } from 'services/generated';
import { GetNotifiedButton } from './GetNotifiedButton';
import { useGetProductDetailsQuery } from 'store/slices/products-api';
import { OrderTypeModalCallable } from 'app/_authenticated/trade/components/OrderTypeModal/OrderTypeModal';

export function ExploreActionButton({
  productCode,
  productType,
  isTracked,
  isMobile
}: {
  productCode: string;
  productType: ActiveProductDtoTypeEnum;
  isTracked: boolean;
  isMobile: boolean;
}) {
  const { subscribeLink } =
    productType === ActiveProductDtoTypeEnum.PrivateCredit
      ? getPrivateCreditLinks(productCode)
      : { subscribeLink: undefined };
  return !isTracked ? (
    <GetNotifiedButton isMobile={isMobile} productCode={productCode} />
  ) : (
    <Button
      size="medium"
      className="px-6"
      onPress={() => {
        productType === ActiveProductDtoTypeEnum.PrivateCredit && subscribeLink
          ? window.open(subscribeLink, '_blank')
          : OrderTypeModalCallable.call({
              productCode,
              filter: 'buy',
            });
      }}
      fullWidth={false}
      text={
        productType === ActiveProductDtoTypeEnum.PrivateCredit
          ? 'Subscribe'
          : 'Buy'
      }
    />
  );
}

const getPrivateCreditLinks = (
  productCode: string,
): {
  redeemLink?: string;
  subscribeLink?: string;
} => {
  const { data: productDetails } = useGetProductDetailsQuery(productCode);
  return {
    redeemLink: productDetails?.productCopy?.redeemLink,
    subscribeLink: productDetails?.productCopy?.earlyAccessLink,
  };
};
